import { Environment } from '~/engine/data/Environment';
import { RegionOfInterest } from '~/engine/data/structure/RegionOfInterest';
import {
    DeformAction,
    DeformActionState,
} from '../../actions/contouring-actions/DeformAction';
import { StrokeMode } from '~/state/atoms/toolsAtoms';
import { CircleCursorStrokeTool } from './CircleCursorStrokeTool';

/**
 * {@link DeformTool} deforms an existing ROI's SDF by dragging its
 * surface. In 3D mode the warp is volumetric around the cursor; in 2D
 * mode it is confined to the current slice of the deformed view.
 *
 * Delegates stroke state management to {@link DeformAction} /
 * {@link DeformActionState}, and the cursor and stroke interaction to
 * {@link CircleCursorStrokeTool}.
 */
export class DeformTool extends CircleCursorStrokeTool<
    DeformActionState,
    DeformAction
> {
    public readonly toolType = 'deform';

    private readonly _mode: StrokeMode;

    public constructor(
        structure: RegionOfInterest,
        environment: Environment | undefined,
        diameter: number,
        mode: StrokeMode,
        diameterChangedCallback: (diameter: number) => void
    ) {
        super(structure, environment, diameter, diameterChangedCallback);
        this._mode = mode;
    }

    public get mode(): StrokeMode {
        return this._mode;
    }

    protected override isStrokeConfinedToPlane(): boolean {
        return this._mode === '2d';
    }

    protected override createAction(): DeformAction {
        return new DeformAction(this.structure, this.diameter, this._mode);
    }
}
